import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { Location } from '@angular/common';

@Pipe({
  name: 'safeHtml',
  standalone: true
})
export class SafeHtmlPipe implements PipeTransform {
  constructor(private sanitizer: DomSanitizer, private location: Location) {}

  transform(html: string): SafeHtml {
    if (!html) {
      return '';
    }

    const baseHref = this.location.prepareExternalUrl('');
    const rewritten = html.replace(
      /href="\/([^"]*)"/g,
      (_: string, path: string) => `href="${baseHref}${path}"`
    );

    return this.sanitizer.bypassSecurityTrustHtml(rewritten);
  }
}
